import React from "react";
import { Link } from "react-router-dom";
import { differentiators, engagements } from "./engagementData";
import "./Engagements.css";

/**
 * The body of the /success page.
 *
 * Replaces a carousel of one-line claims that named no one, said little, and
 * carried percentages. Each engagement is now situation / approach / result,
 * described by sector rather than by customer.
 */
function Engagements() {
  return (
    <>
      <section className="why" aria-labelledby="why-heading">
        <div className="container">
          <h2 className="why__heading" id="why-heading">
            Why engineering teams work with us
          </h2>
          <p className="why__intro">
            Most of what we build starts the same way: a task an engineer
            repeats on every programme, that follows rules clear enough to
            automate but detailed enough to get wrong by hand.
          </p>

          <div className="why__grid">
            {differentiators.map((item) => (
              <article className="why__item" key={item.id}>
                <h3 className="why__item-title">{item.title}</h3>
                <p className="why__item-body">{item.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="engagements" aria-labelledby="engagements-heading">
        <div className="container">
          <h2 className="engagements__heading" id="engagements-heading">
            Selected engagements
          </h2>
          <p className="engagements__intro">
            Client work is described by sector rather than by name. We do not
            publish customer identities or their product data.
          </p>

          <div className="engagements__list">
            {engagements.map((item) => (
              <article className="engagement" key={item.id}>
                <p className="engagement__sector">{item.sector}</p>
                <h3 className="engagement__title">{item.title}</h3>

                <dl className="engagement__detail">
                  <dt>The situation</dt>
                  <dd>{item.situation}</dd>
                  <dt>What we built</dt>
                  <dd>{item.approach}</dd>
                  <dt>What changed</dt>
                  <dd>{item.result}</dd>
                </dl>
              </article>
            ))}
          </div>

          <div className="engagements__cta">
            <p className="engagements__cta-text">
              If one of these sounds like your team, the conversation usually
              starts with a single task and what it currently costs you.
            </p>
            <Link to="/contact" className="engagements__cta-button">
              Start that conversation
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Engagements;
